import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-defaults',
  templateUrl: './defaults.component.html',
  styleUrls: ['./defaults.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefultsComponent implements OnInit, OnDestroy {
  @Input() SettingForm: FormGroup;
  @Input() errorWarningData: any;
  @Input() getDropDownValue: any;
  texVal: any = [];
  incomeTypeArray: any = [];
  matterclassArray: any = [];
  shortNameArray: any = [];
  sundryFreeEarnerArray: any = [];
  isspiner: boolean = false;
  currentUser: any = JSON.parse(localStorage.getItem('currentUser'));
  private _unsubscribeAll$: Subject<void> = new Subject();
  sub: Subscription;
  activitiesArray: any[] = [];
  // getDropDownValue: any = [];
  constructor(
    private _mainAPiServiceService: MainAPiServiceService,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
  ) {
    localStorage.setItem('istrackid', 'SystemSettingDefultsComponent');
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit() {
    this.loadData();
    // this._mainAPiServiceService.getSetData({EXCLUDESYSTEMACCOUNTS :true,EXCLUDEINVOICETEMPLATESETTINGS:true}, 'GetSystem').subscribe(response => {
    //   this.getDropDownValue = response.DATA.LISTS;
    //   this.behaviorService.loadingSystemSetting('defaults');
    // })
  }

  loadData() {
    let Activitydata: any = {
      Action: 'GetData',
      Filters: {
        ACTIVITYTYPE: 'Sundries',
      },
    };
    this.isspiner = true;
    this.sub = this._mainAPiServiceService.getSetData(Activitydata, 'activity').subscribe({
      next: (response: any) => {
        if (response.CODE === 200 && (response.STATUS === 'OK' || response.STATUS === 'success')) {
          this.isspiner = false;
          this.activitiesArray = response.DATA.RECORDS;
        } else {
          this.isspiner = false;
          this.activitiesArray = [];
        }
        this.cd.markForCheck();
      },
      error: (error: any) => {
        this.isspiner = false;
        this.toastr.error(error);
        this.cd.markForCheck();
      },
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
    this.sub?.unsubscribe();
  }

  /**
   * save the defaults of system settings
   */
  saveDefaults() {
    const originalValue = this.SettingForm.controls.AUTOMATICNEWMATTERSUNDRY.value;
    let partBeforeDash, partAfterDash;
    if (originalValue) {
      const parts = originalValue.split(' - ');
      partBeforeDash = parts[0];
      partAfterDash = parts[1];
    }
    this.isspiner = true;
    let data = {
      GroupName: 'BusinessSetup',
      SubgroupName: 'Defaults',
      DEFAULTEXPENSETYPE: this.SettingForm.controls.DEFAULTEXPENSETYPE.value,
      DEFAULTPAIDTYPE: this.SettingForm.controls.DEFAULTPAIDTYPE.value,
      DEFAULTINCOMETYPE: this.SettingForm.controls.DEFAULTINCOMETYPE.value,
      DEFAULTMATTERCLASS: this.SettingForm.controls.DEFAULTMATTERCLASS.value,
      SHORTNAMESTRATEGY: this.SettingForm.controls.SHORTNAMESTRATEGY.value,
      REQUIRECOSTAGREEMENT: this.SettingForm.controls.REQUIRECOSTAGREEMENT.value,
      OFFICECHEQUEFORMAT: this.SettingForm.controls.OFFICECHEQUEFORMAT.value,
      REQUIREMATTEROWNER: this.SettingForm.controls.REQUIREMATTEROWNER.value,
      REQUIREFEEEARNER: this.SettingForm.controls.REQUIREFEEEARNER.value,
      SUNDRYFEEEARNER: this.SettingForm.controls.SUNDRYFEEEARNER.value,
      REQUIREMATTERTYPE: this.SettingForm.controls.REQUIREMATTERTYPE.value,
      REQUIRECLIENTSOURCE: this.SettingForm.controls.REQUIRECLIENTSOURCE.value,
      REQUIREFIELDOFLAW: this.SettingForm.controls.REQUIREFIELDOFLAW.value,
      CHARGEDISBGSTONGSTFREEMATTERS: this.SettingForm.controls.CHARGEDISBGSTONGSTFREEMATTERS.value,
      REQUIREEXPENSEPAYEE: this.SettingForm.controls.REQUIREEXPENSEPAYEE.value,
      SHOWCONFLICTCHECKFORNEWMATTER: this.SettingForm.controls.SHOWCONFLICTCHECKFORNEWMATTER.value,
      NEWMATTERSUNDRYFEE: originalValue ? partBeforeDash : '',
      NEWMATTERSUNDRYFEEGUID: originalValue ? partAfterDash : '',
    };
    let data1 = { Action: 'Update', Data: data };
    this._mainAPiServiceService
      .getSetData(data1, 'system')
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe({
        next: (response: any) => {
          if (response.CODE == 200 && (response.STATUS == 'OK' || response.STATUS == 'success')) {
            this.isspiner = false;
            this.currentUser['SHOWCONFLICTCHECKFORNEWMATTER'] =
              this.SettingForm.controls.SHOWCONFLICTCHECKFORNEWMATTER.value;
            this.currentUser['CHARGEDISBGSTONGSTFREEMATTERS'] =
              this.SettingForm.controls.CHARGEDISBGSTONGSTFREEMATTERS.value;
            this.currentUser['DEFAULTMATTERCLASS'] =
              this.SettingForm.controls.DEFAULTMATTERCLASS.value;
            localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
            this.toastr.success('Updated successfully');
          } else if (
            (response.CODE == 451 || response.CODE == 450) &&
            response.STATUS == 'warning'
          ) {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else if ((response.CODE == 450 || response.CODE == 451) && response.STATUS == 'error') {
            this.isspiner = false;
            this.toastr.warning(response.MESSAGE);
          } else {
            this.isspiner = false;
          }
          this.cd.markForCheck();
        },
        error: (error: any) => {
          this.isspiner = false;
          this.toastr.error(error);
          this.cd.markForCheck();
        },
      });
  }
}
